import { PAGE_SIZE } from '../api/queries';

/** The page size of a list from its `?limit=` URL parameter (1–200), else the default. */
export function listLimit(text: string | null): number {
  if (!text || !/^\d{1,3}$/.test(text)) return PAGE_SIZE;
  const value = Number(text);
  return value >= 1 && value <= 200 ? value : PAGE_SIZE;
}

/** Sets or removes one URL parameter, keeping the others. */
export function withParam(search: URLSearchParams, name: string, value: string | null): URLSearchParams {
  const next = new URLSearchParams(search);
  if (value) next.set(name, value);
  else next.delete(name);
  return next;
}
